module.exports = require('./helpers/bundle-url').getBundleURL('15MIF') + "card-visa.1a546991.svg";